import React, { useState } from "react";
import { ItemList } from "../components";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Link } from "react-router-dom";

import { BsArrowRight } from "react-icons/bs";

const BusinessList = () => {
  const business = [
    {
      is_new: true,
      is_for_sale: true,
      link: "/business-details",
      title: "Borrett Close, London",
      price: "£689,000",
      marks: 2.5,
      imgsrc: [
        "./assets/img/1920x1080/img19.jpg",
        "./assets/img/1920x1080/img20.jpg",
        "./assets/img/1920x1080/img17.jpg",
        "./assets/img/1920x1080/img16.jpg",
      ],
    },
    {
      is_new: false,
      is_for_sale: false,
      link: "/business-details",
      title: "Borrett Close, London",
      price: "£89,000",
      marks: 3.5,
      imgsrc: [
        "./assets/img/1920x1080/img1.jpg",
        "./assets/img/1920x1080/img2.jpg",
        "./assets/img/1920x1080/img3.jpg",
        "./assets/img/1920x1080/img4.jpg",
      ],
    },
    {
      is_new: false,
      is_for_sale: true,
      link: "/business-details",
      title: "Harnet Close, Chelsea",
      price: "£6,000",
      marks: 4,
      imgsrc: [
        "./assets/img/1920x1080/img12.jpg",
        "./assets/img/1920x1080/img13.jpg",
        "./assets/img/1920x1080/img14.jpg",
        "./assets/img/1920x1080/img15.jpg",
      ],
    },
    {
      is_new: false,
      is_for_sale: false,
      link: "/business-details",
      title: "Borrett Close, London",
      price: "£89,000",
      marks: 3.5,
      imgsrc: [
        "./assets/img/1920x1080/img1.jpg",
        "./assets/img/1920x1080/img2.jpg",
        "./assets/img/1920x1080/img3.jpg",
        "./assets/img/1920x1080/img4.jpg",
      ],
    },
    {
      is_new: false,
      is_for_sale: true,
      link: "/business-details",
      title: "Harnet Close, Chelsea",
      price: "£6,000",
      marks: 4,
      imgsrc: [
        "./assets/img/1920x1080/img12.jpg",
        "./assets/img/1920x1080/img13.jpg",
        "./assets/img/1920x1080/img14.jpg",
        "./assets/img/1920x1080/img15.jpg",
      ],
    },
    {
      is_new: false,
      is_for_sale: false,
      link: "/business-details",
      title: "Borrett Close, London",
      price: "£89,000",
      marks: 3.5,
      imgsrc: [
        "./assets/img/1920x1080/img1.jpg",
        "./assets/img/1920x1080/img2.jpg",
        "./assets/img/1920x1080/img3.jpg",
        "./assets/img/1920x1080/img4.jpg",
      ],
    },
    {
      is_new: false,
      is_for_sale: true,
      link: "/business-details",
      title: "Harnet Close, Chelsea",
      price: "£6,000",
      marks: 4,
      imgsrc: [
        "./assets/img/1920x1080/img12.jpg",
        "./assets/img/1920x1080/img13.jpg",
        "./assets/img/1920x1080/img14.jpg",
        "./assets/img/1920x1080/img15.jpg",
      ],
    },
  ];

  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div className="container content-space-1">
      <div className="mt-2 mb-4 d-flex justify-content-between align-items-center">
        <span className="h2 text-primary">
          Decouvrez une selection de produit
        </span>
        {/* <Link to={"/market-place"}>
          <button
            className="btn btn-primary btn-sm d-flex align-items-center "
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            //  span wich grow on mouse hover 
            <span className={` me-1 ${isHovered ? "me-2" : ""} `} > All products</span>
            <BsArrowRight size={18} />
          </button>
        </Link> */}
      </div>
      <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3">
        <ItemList items={business} swiper viewer />
        {/* <ImageViewer sources={imgs} toggler={toggler} /> */}
      </div>
    </div>
  );
};

export default BusinessList;
